import { render, staticRenderFns } from "./CargoCrudStatusWaitingDocumentPath.vue?vue&type=template&id=7bdc2e0e"
import script from "./CargoCrudStatusWaitingDocumentPath.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusWaitingDocumentPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports